import { sanitizeHtml } from "./sanitize";

export default function renderOembed(html: string | undefined) {
  if (!html) return "<p>No content yet.</p>";

  const replaced = html.replace(/<oembed url="(.*?)"><\/oembed>/g, (_match: string, url: string) => {
    const youtubeMatch = url.match(/(?:v=|\/)([a-zA-Z0-9_-]{11})/);
    if (!youtubeMatch) return "";
    const videoId = youtubeMatch[1];

    return `
      <div class="relative pb-[56.25%] h-0 overflow-hidden">
        <iframe
          class="absolute top-0 left-0 w-full h-full"
          src="https://www.youtube.com/embed/${videoId}"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    `;
  });

  return sanitizeHtml(replaced);
}
